import {
  Autocomplete,
  Box,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  MenuItem,
  Typography
} from '@mui/material';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { DropzoneArea } from 'mui-file-dropzone';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { PopupComponent } from 'src/components/common/PopupComponent';
import ProgressBar from 'src/components/common/ProgressBar';
import { sendRequest } from 'src/hooks/useFetch';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { setMessage } from 'src/store/Message';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { formatInput } from 'src/util/STR';
import { useFieldTranslation } from '../../fields/useFieldTranslation';
import VersionControl from '../../versionControl/VersionControl';
import { useDocumentUploads } from '../documentUpload/useDocumentUploads';
import './IpManagement.scss';
import { hideLoader, showLoader } from 'src/store/Loader';

interface addDocPropTypes {
  open: boolean;
  setOpen: any;
  ipReleaseData: [];
  createIPRelease: any;
  checkboxVal: any;
  updatedIPReleaseDocs: any;
  validateMandatoryFields: any;
}
export default function AddDocumentModal({
  setOpen,
  ipReleaseData,
  createIPRelease,
  checkboxVal,
  updatedIPReleaseDocs,
  validateMandatoryFields
}: addDocPropTypes) {
  const useStyles = makeStyles(() =>
    createStyles({
      previewChip: {
        minWidth: 160,
        maxWidth: 210
      }
    })
  );

  const { createMasterDocumentEtmf, getAllDocsByArtifactName, getDocLevelByArtifactName, getTmfLevelQuery } =
    useDocumentUploads();

  const classes = useStyles();
  const { ipmFileuploadErrorMsg, ipmFileAddSuccessMsg } = useFieldTranslation();
  const dispatch = useDispatch();
  const dispatchApp = useAppDispatch();
  const [openVersion, setOpenVersion] = useState(false);
  const [selectData, setSelectData] = useState<any>([]);
  const [isUpload, setIsUpload] = useState<boolean>(false);
  const [dfile, setDfile] = useState<any>(null);
  const studyList: any[] = [];
  const [artifactNameList, setArtifactNameList] = useState<any>([]);
  const [artifactName, setArtifactName] = useState<any>();
  const [resData, setResData] = useState<any>();
  const [enable, setEnable] = useState<boolean>(false);
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector((state: any) => state.site.selectedCountry);
  const selectedSite = useAppSelector((state: any) => state.site.selectedSite);
  const [styleUpload, setStyleUpload] = useState('uploadFile');
  const [error, setError] = useState<any>(null);
  const { preferedDateFormat, userPreferedDateFormat } = usePreferedDateFormat();
  const [submitDisable, setSubmitDisable] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isArtifactsLoading, setIsArtifactsLoading] = useState(false);

  const [metaData, setMetaData] = useState<any>({
    tmf_artifact_number: '',
    tmf_document_name: '',
    tmf_document_type: '',
    tmf_document_subtype: '',
    tmf_doc_date: new Date().toISOString().split('T')[0],
    tmf_doc_country: selectedCountry,
    tmf_doc_study: studyId,
    tmf_doc_site: selectedSite,
    tmf_doc_level: 'Site',
    tmf_artifact_name: '',
    tmf_doc_version_number: 1,
    tmf_doc_milestone: ''
  });

  const initialState = {
    tmf_artifact_number: '',
    tmf_document_name: '',
    tmf_document_type: '',
    tmf_document_subtype: '',
    tmf_doc_date: new Date().toISOString().substring(0, 10),
    tmf_doc_country: '',
    tmf_doc_study: '',
    tmf_doc_site: '',
    tmf_doc_level: 'Site',
    tmf_artifact_name: '',
    tmf_doc_version_number: 1,
    tmf_doc_milestone: ''
  };

  const [isLoading, setIsLoading] = useState(false);

  interface dataUpload {
    created_on: string;
    id: string;
    is_active: boolean;
    tmf_bucket_name: string;
    tmf_doc_created_by: string;
    tmf_doc_pages: string;
    tmf_doc_size: string;
    tmf_doc_type: string;
    tmf_doc_upload_date: string;
    tmf_doc_version_number: number;
    tmf_hashed_file_name: string;
    tmf_prefix: string;
    tmf_raw_file_name: string;
    updated_on: string;
  }

  const uploadFile = async (file: any): Promise<dataUpload> => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      const options = {
        endPointEnv: 'etmf',
        data: formData,
        pathVariables: {
          study_id: studyId,
          country: selectedCountry,
          site_id: selectedSite,
          appName: process.env.REACT_APP_NAME,
          audit_module_section: 'IP MANAGEMENT',
          parent_entity_related: ''
        }
      };
      const response: any = await sendRequest('ip_management_add_doc_upload_file', options);
      return response;
    } catch (error) {
      dispatchApp(setMessage({ msgDetails: ipmFileuploadErrorMsg, severity: 'error' }));
      return Promise.reject();
    }
  };

  const uploadDataFile = async (): Promise<any> => {
    if (dfile) {
      const result = await uploadFile(dfile);
      if (result?.tmf_doc_version_number) {
        setResData(result);
        setMetaData({
          ...metaData,
          tmf_doc_version_number: result.tmf_doc_version_number,
          tmf_doc_date: result.updated_on,
          tmf_document_id: result.id
        });
        return result;
      } else {
        return false;
      }
    }
  };

  const handlechangeTmfLevel = (level: any) => {
    setMetaData({ ...metaData, tmf_doc_level: level });
    getTmfDataResponse(level);
  };

  const handleCancel = () => setEnable(true);
  const handleClose = () => setEnable(false);

  const clearData = () => {
    setDfile('');
    setIsUpload(false);
    setSubmitDisable(false);
    setMetaData({ ...initialState });
    setOpen(false);
  };

  const handleRejectedMessage = (rejectedFile: any, acceptedFiles: any, maxFileSize: any) => {
    let message = `${rejectedFile.name} cannot be uploaded! , `;
    const arrFile = rejectedFile.name.split('.');
    if (!acceptedFiles.includes(`.${arrFile[arrFile.length - 1]}`)) {
      message += `File Format is not supported.`;
    } else if (rejectedFile.size > maxFileSize) {
      message += ` File Size more than 5MB is not allowed`;
    }
    return message;
  };

  const handleStudyChange = async (study_id: string) => {
    try {
      const options = {
        pathVariables: {
          site_id: selectedSite,
          study_id,
          country: selectedCountry,
          appName: process.env.REACT_APP_NAME
        }
      };
      const response: any = await sendRequest('get_study_site_country', options);
      setMetaData({
        ...metaData,
        tmf_doc_site: response[0].site_id,
        tmf_doc_country: response[0].country,
        tmf_doc_study: response[0].study_id
      });
    } catch (error) {
      setIsArtifactsLoading(false);
    }
  };

  // Get Artifact details based on doc level and artifact name
  const getArtifactNameResponse = async (artifactName: string) => {
    setIsArtifactsLoading(true);
    const result: any = await getDocLevelByArtifactName({
      tmf_doc_level: metaData.tmf_doc_level,
      tmf_artifact_name: artifactName,
      application: process.env.REACT_APP_NAME,
      module_section_related: 'IP MANAGEMENT',
      parent_entity_related: ''
    });
    if (result?.data) {
      setMetaData({
        ...metaData,
        tmf_artifact_name: artifactName,
        tmf_artifact_number: result?.data.tmf_artifact_number,
        tmf_document_subtype: result?.data.tmf_doc_subtype,
        tmf_document_type: result?.data.tmf_doc_type,
        tmf_doc_milestone: result?.data.tmf_doc_milestone,
        application: process.env.REACT_APP_NAME,
        module_section_related: 'IP MANAGEMENT',
        parent_entity_related: ''
      });
    } else if (result?.error) {
      if (result?.error.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (result?.error.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      }
    }
    setIsArtifactsLoading(false);
  };

  // getting artifact names and error handling for 401 and 403
  const getTmfDataResponse = async (level: any) => {
    setIsLoading(true);
    const result: any = await getTmfLevelQuery({
      tmf_level: level,
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: process.env.REACT_APP_NAME,
      module_section_related: 'IP MANAGEMENT',
      parent_entity_related: ''
    });
    if (result?.data) {
      setArtifactNameList(result?.data);
    } else if (result?.error) {
      setArtifactNameList([]);
      if (result?.error.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (result?.error.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      }
    }
    setIsLoading(false);
  };

  const handleChangeArtifactNameSelection = (e: any) => {
    if (e.target.value !== '') {
      setMetaData({ ...metaData, tmf_artifact_name: e.target.value });
      setArtifactName(e.target.value);
      getArtifactNameResponse(e.target.value);
    }
  };

  const handleClickArtifactName = (e: any) => {
    if (e.target.value == '' || e.target.value === undefined) {
      setArtifactName(e.target.value);
      setMetaData({
        ...metaData,
        tmf_artifact_name: '',
        tmf_doc_milestone: '',
        tmf_document_type: '',
        tmf_document_subtype: '',
        tmf_artifact_number: ''
      });
    }
  };

  const handleDocumentName = (e: any) => {
    const val = e.target.value;
    const formattedVal = typeof val === 'string' ? formatInput(val) : val;
    setMetaData({ ...metaData, tmf_document_name: formattedVal });
  };

  useEffect(() => {
    handlechangeTmfLevel('Site');
  }, []);

  useEffect(() => {
    handleStudyChange(studyId);
  }, [selectedSite]);

  useEffect(() => {
    if (dfile) {
      setIsUpload(true);
      setSubmitDisable(true);
    } else {
      setIsUpload(false);
    }
  }, [dfile]);

  useEffect(() => {
    if (isUpload) {
      setStyleUpload('uploadFileSuccess');
    } else {
      setStyleUpload('uploadFile');
    }
  }, [isUpload]);

  useEffect(() => {
    if (isUpload) {
      if (error) {
        setStyleUpload('uploadFileError');
      } else {
        setStyleUpload('uploadFileSuccess');
      }
    } else {
      setStyleUpload('uploadFile');
    }
  }, [isUpload, error]);

  useEffect(() => {
    if (dfile) {
      const eleButton = document.getElementsByTagName('input');
      for (let i = 0; i < eleButton.length; i++) {
        if (eleButton[i].type === 'file') {
          const eleFile = eleButton[i] as HTMLElement;
          eleFile.style.cssText = 'display: none!important';
        }
      }
    }
  }, [dfile]);

  const handleUploadFile = async (Res: any, Meta: any, artifactName: any, isSubmit: boolean) => {
    setSubmitDisable(false);
    setIsSubmitLoading(true);
    const check = await uploadDataFile();
    if (!check) {
      return;
    }
    setError(null);
    const docData: any = {
      file_master_id: check.id,
      document_data: {
        tmf_artifact_number: Meta.tmf_artifact_number,
        tmf_document_name: Meta.tmf_document_name,
        tmf_doc_type: Meta.tmf_document_type,
        tmf_doc_subtype: Meta.tmf_document_subtype,
        sent_to_isf: false,
        tmf_doc_status: 'Uploaded',
        tmf_doc_country:
          Meta.tmf_doc_level === 'Country' || Meta.tmf_doc_level === 'Site' ? Meta.tmf_doc_country : null,
        tmf_doc_study: Meta.tmf_doc_study,
        tmf_doc_site: Meta.tmf_doc_level === 'Site' ? Meta.tmf_doc_site : null,
        tmf_doc_viewer_language: 'English',
        tmf_doc_viewer_approval_cycle: 0,
        tmf_doc_viewer_product_detail: 'string',
        tmf_doc_viewer_ref_model_version: 'TMF RM 3.2.1',
        tmf_doc_viewer_format: check.tmf_doc_type,
        tmf_doc_viewer_inspection_ready: 'string',
        tmf_doc_viewer_ir_issue_type: 'string',
        tmf_doc_level: metaData.tmf_doc_level,
        tmf_artifact_name: artifactName,
        tmf_doc_viewer_req_certified_copy: 'N',
        tmf_doc_viewer_department: 'None',
        tmf_doc_version_number: Meta.tmf_doc_version_number,
        tmf_doc_milestone: Meta.tmf_doc_milestone,
        tmf_doc_created_by: check.tmf_doc_created_by,
        tmf_document_id: 'str'
      }
    };
    if (updatedIPReleaseDocs?.length > 0 || checkboxVal) {
      validateMandatoryFields();
    }
    getDocumentDetails(Meta, docData, isSubmit);
    setIsSubmitLoading(false);
    setIsUpload(false);
  };

  const postData = async (docData: any, isSubmit: any) => {
    const result: any = await createMasterDocumentEtmf({
      data: docData,
      study_id: studyId,
      country: selectedCountry,
      site_id: selectedSite,
      application: process.env.REACT_APP_NAME,
      module_section_related: 'IP MANAGEMENT',
      parent_entity_related: ''
    });

    if (result?.data) {
      const response = result?.data;
      const isNewDocExistsInIPReleaseData = ipReleaseData.some(
        (releaseDoc: any) => releaseDoc.ip_management_number === response.document_data.tmf_artifact_number
      );
      if (!isNewDocExistsInIPReleaseData) {
        const mockObj = {
          artifact_tooltip: '',
          ip_management_document: response.document_data.tmf_artifact_name,
          ip_management_number: response.document_data.tmf_artifact_number,
          ip_management_comment: ''
        };
        const modifiedObj = [];
        modifiedObj.push(mockObj);
        createIPRelease(modifiedObj);
        setConfirmExitValue(dispatch, true);
      }
      dispatchApp(setMessage({ msgDetails: ipmFileAddSuccessMsg, severity: 'success' }));
      isSubmit && setOpen(false);
    } else if (result?.error) {
      if (result?.error.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (result?.error.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      } else {
        dispatch(setMessage({ msgDetails: ipmFileuploadErrorMsg, severity: 'error' }));
      }
    }
  };

  const handleCloseVersion = () => {
    setOpenVersion(false);
    setDfile('');
    setIsUpload(false);
    setMetaData({ ...initialState });
    setOpen(false);
  };

  const handleBackVersion = () => {
    setOpen(true);
    setOpenVersion(false);
    setIsUpload(true);
  };

  const getDocumentDetails = async (metaData: any, docData: any, isSubmit: any) => {
    const country = metaData.tmf_doc_level === 'Study' ? '' : metaData.tmf_doc_country;
    const site =
      metaData.tmf_doc_level === 'Study' || metaData.tmf_doc_level === 'Country' ? '' : metaData.tmf_doc_site;
    const res: any = await getAllDocsByArtifactName({
      country,
      site_id: site,
      study_id: studyId,
      artifactName,
      docLevel: metaData.tmf_doc_level,
      application: process.env.REACT_APP_NAME,
      module_section_related: 'IP MANAGEMENT',
      parent_entity_related: ''
    });
    if (res?.isSuccess) {
      const result: any = res?.data && res?.data.selected_data.length > 0 ? res?.data.selected_data : [];
      if (result.length > 0) {
        setSelectData(result[0]);
        (metaData.tmf_doc_level === result[0].document_data.tmf_doc_level &&
          metaData.tmf_doc_study === result[0].document_data.tmf_doc_study &&
          metaData.tmf_artifact_name === result[0].document_data.tmf_artifact_name) ||
        metaData.tmf_doc_country === result[0].document_data.tmf_doc_country ||
        metaData.tmf_doc_site === result[0].document_data.tmf_doc_site
          ? setOpenVersion(true)
          : postData(docData, isSubmit);
      }
    } else if (res?.error) {
      postData(docData, isSubmit);
      setDfile('');
      setIsUpload(false);
      isSubmit && setOpen(false);
    }
  };
  useEffect(() => {
    if (isSubmitLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [isSubmitLoading]);

  return (
    <div className="document-upload-page">
      <div className="card">
        <Grid container spacing={3}>
          <Grid item md={12}>
            <div id="uploadFile" className={styleUpload}>
              <DropzoneArea
                fileObjects={[]}
                showPreviewsInDropzone={isUpload}
                filesLimit={1}
                maxFileSize={5000000}
                acceptedFiles={[
                  '.jpg',
                  '.jpeg',
                  '.gif',
                  '.png',
                  '.bmp',
                  '.tif',
                  '.tiff',
                  '.psd',
                  '.pdf',
                  '.doc',
                  '.docx',
                  '.xls',
                  '.xlsx'
                ]}
                useChipsForPreview
                showFileNames={false}
                dropzoneText={
                  isUpload ? 'Your file upload has been successfully initiated' : `Drag and drop your file here or`
                }
                previewGridProps={{ container: { spacing: 1, direction: 'row' } }}
                previewChipProps={{ classes: { root: classes.previewChip } }}
                previewText="Selected files"
                onChange={e => setDfile(e[0])}
                getFileLimitExceedMessage={(_: number) =>
                  'You cannot upload more than one file at once. Please try with single file'
                }
                getDropRejectMessage={handleRejectedMessage}
              />
              <Typography
                variant="body2"
                display="block"
                color="text.secondary"
                gutterBottom
                sx={{ mt: -4, textAlign: 'center', position: 'relative', zIndex: 12 }}
              >
                <strong>Accepted file type:&nbsp;</strong>
                {[
                  '.jpg',
                  '.jpeg',
                  '.gif',
                  '.png',
                  '.bmp',
                  '.tif',
                  '.psd',
                  '.pdf',
                  '.doc',
                  '.docx',
                  '.xls',
                  '.xlsx'
                ].toString()}
              </Typography>
            </div>
          </Grid>
          {/* {isLoading && <ProgressBar />} */}
          <Grid item md={12}>
            <Grid container spacing={2}>
              <Grid item md={4}>
                <FormControl fullWidth margin="normal">
                  <TextField
                    required
                    id="standard-select-currency-native"
                    label="Document Name "
                    variant="standard"
                    value={metaData.tmf_document_name}
                    inputProps={{
                      maxLength: 200
                    }}
                    onChange={e => handleDocumentName(e)}
                  />
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    id="standard-select-currency-native"
                    select
                    label="Country"
                    InputProps={{
                      readOnly: true
                    }}
                    defaultValue=""
                    value={metaData.tmf_doc_level === 'Study' ? '' : metaData.tmf_doc_country}
                    variant="standard"
                  >
                    <MenuItem value={metaData.tmf_doc_country}>{metaData.tmf_doc_country}</MenuItem>
                  </TextField>
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    id="standard-select-currency-native"
                    label="Version Number"
                    variant="standard"
                    value={isUpload ? parseFloat(metaData.tmf_doc_version_number).toFixed(1) : ''}
                  />
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <TextField
                    id="standard-select-currency-native"
                    label="Subtype"
                    variant="standard"
                    value={metaData.tmf_document_subtype}
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item md={4}>
                <FormControl fullWidth margin="normal">
                  <TextField
                    required
                    disabled
                    id="standard-required"
                    select
                    label="TMF Level"
                    defaultValue=""
                    value={metaData.tmf_doc_level}
                    variant="standard"
                    InputProps={{
                      readOnly: true
                    }}
                    onChange={e => {
                      handlechangeTmfLevel(e.target.value);
                    }}
                  >
                    <MenuItem value="Study">Study</MenuItem>
                    <MenuItem value="Country">Country</MenuItem>
                    <MenuItem value="Site">Site</MenuItem>
                  </TextField>
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    required={metaData.tmf_doc_level === 'Site'}
                    id="standard-select-currency-native"
                    select
                    value={
                      metaData.tmf_doc_level === 'Study' || metaData.tmf_doc_level === 'Country'
                        ? ''
                        : metaData.tmf_doc_site
                    }
                    label="Site"
                    variant="standard"
                    InputProps={{
                      readOnly: true
                    }}
                    onChange={() => {
                      //handleSiteChange(e);
                    }}
                  >
                    <MenuItem value={metaData.tmf_doc_site}>{metaData.tmf_doc_site}</MenuItem>
                  </TextField>
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <TextField
                    id="standard-select-currency-native"
                    label="Milestone"
                    variant="standard"
                    value={metaData.tmf_doc_milestone}
                    disabled
                  />
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <TextField
                    id="standard-select-currency-native"
                    label="Artifact Number"
                    variant="standard"
                    value={metaData.tmf_artifact_number}
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item md={4}>
                <FormControl fullWidth margin="normal">
                  <Autocomplete
                    disablePortal
                    id="standard-select-currency-native"
                    options={studyList}
                    value={metaData.tmf_doc_study}
                    renderInput={params => (
                      <TextField
                        {...params}
                        onSelect={(e: any) => {
                          handleStudyChange(e.target.value);
                        }}
                        required
                        disabled
                        InputProps={{
                          readOnly: true
                        }}
                        label="Study"
                        variant="standard"
                      />
                    )}
                  />
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <Autocomplete
                    disablePortal
                    id="standard-select-currency-native"
                    options={artifactNameList}
                    loading={isLoading}
                    renderInput={params => (
                      <TextField
                        {...params}
                        onSelect={e => {
                          handleChangeArtifactNameSelection(e);
                        }}
                        onClick={e => {
                          handleClickArtifactName(e);
                        }}
                        required
                        label="Artifact Name"
                        variant="standard"
                        value={metaData.tmf_artifact_name ? metaData.tmf_artifact_name : ''}
                      />
                    )}
                  />
                </FormControl>
                {isArtifactsLoading && (
                  <Box style={{ marginTop: '-9    px' }}>
                    <ProgressBar />
                  </Box>
                )}

                <FormControl fullWidth margin="normal">
                  <TextField
                    id="standard-select-currency-native"
                    label="Type"
                    variant="standard"
                    value={metaData.tmf_document_type}
                    disabled
                  />
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    id="standard-select-currency-native"
                    label="Upload Date"
                    placeholder={userPreferedDateFormat.toLowerCase()}
                    variant="standard"
                    type={isUpload ? 'text' : ''}
                    value={isUpload ? preferedDateFormat(metaData.tmf_doc_date.split('T')[0]) : ''}
                  />
                </FormControl>
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item md={12} display="flex" justifyContent="flex-end">
                <Stack direction="row" spacing={2}>
                  <Button href="#contained-buttons" className="grey-btn" onClick={handleCancel}>
                    Cancel
                  </Button>
                  <PopupComponent
                    open={enable}
                    aria-labelledby="alert-dialog-title"
                    child
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">{'Cancel Document Upload'}</DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Are you sure you want to cancel uploading this document?
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={clearData} autoFocus className="grey-btn">
                        Yes
                      </Button>
                      <Button onClick={handleClose}>No</Button>
                    </DialogActions>
                  </PopupComponent>
                  <Button
                    onClick={() => handleUploadFile(resData, metaData, artifactName, true)}
                    disabled={
                      !dfile ||
                      !metaData.tmf_doc_level ||
                      !metaData.tmf_doc_study ||
                      !metaData.tmf_artifact_number ||
                      !metaData.tmf_document_name ||
                      !submitDisable
                    }
                  >
                    Submit
                  </Button>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
      {openVersion && (
        <PopupComponent maxWidth="sm" open={openVersion}>
          <VersionControl
            resData={resData}
            metaData={metaData}
            selectData={selectData}
            setSubmitDisable={setSubmitDisable}
            setSelectData={setSelectData}
            setMetaData={setMetaData}
            ipReleaseData={ipReleaseData}
            createIPRelease={createIPRelease}
            handleCloseVersion={handleCloseVersion}
            handleBackVersion={handleBackVersion}
            artifactName={artifactName}
          />
        </PopupComponent>
      )}
    </div>
  );
}
